import { useContext, useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import { SessionContext } from "../../context/SessionContext";
import * as Permissions from "../supportFunctions/Permissions";
import { Unauthorized } from "@velocity-ehs/component-library";
import UsersService from "@velocity-ehs/user-utils-module";

const PrivateRoute = ({
  title,
  component,
  viewPermissions = [],
  showIfAnyPermission = false,
  featureFlag = true,
  ...rest
}) => {
  const history = useHistory();

  useEffect(() => {
    document.title = title || "";
  }, [title]);

  const { isLoading } = useContext(SessionContext);
  const { permissions } = UsersService;
  const unauthorized = <Unauthorized navigate={history.push} />;

  if (isLoading) return <></>;
  if (featureFlag === false) return unauthorized;

  return (
    <Route {...rest}>
      {Permissions.IsAllowed(viewPermissions, permissions, showIfAnyPermission)
        ? component
        : unauthorized}
    </Route>
  );
};

export default PrivateRoute;
